export default "__VITE_ASSET__DHHA4B_4__"